import React from 'react';
import Img from 'react-image';
import classNames from 'classnames/bind';
import { Link } from '@reach/router';

import styles from './we.module.scss';
import drinksImg from '../../img/drinks.png';

let cx = classNames.bind(styles);

const We = () => {

	return (
		<section id='nosotros' className={cx({ we: true })}>
			<div className='container mx-auto flex flex-col items-center'>
				<div className='w-full justify-center items-center'>
					<Img src={drinksImg} className='w-full px-16' />
				</div>
				<div className='w-4/12 border-b-2 border-ccu-dark my-4'></div>
				<div className='flex flex-col text-ccu-green w-full items-center'>
					<h1 className='text-4xl lg:text-6xl font-Ubuntu-Light'>
						Quiénes <strong className='font-Ubuntu-Bold'>Somos</strong>
					</h1>
					<p className='text-ccu-dark text-2xl font-bold text-center font-Ubuntu-Bold'>
						Somos una empresa multicategoría de bebidas, con operaciones en
						<br />
						<span className='text-ccu-green text-xl'>
							Chile, Argentina, Bolivia, Colombia, Paraguay y Uruguay.
						</span>
					</p>
				</div>
				<div className='flex flex-col items-center lg:flex-row text-ccu-green w-10/12 items-center border shadow shadow-lg my-4 py-4'>
					<div className='flex justify-center items-center flex-1 h-40 px-6 py-4 border-b-2 lg:border-b-0 lg:border-r-2 border-ccu-green sm:w-full'>
						<h1 className='text-ccu-dark font-Ubuntu-Regular text-xl text-center'>
							<strong className='text-xl font-Ubuntu-Bold'>7 centros</strong> <br />
								productivos y 6 centros de distribución
							<strong className='font-Ubuntu-Bold'> en el país</strong>
						</h1>
					</div>
					<div className='flex justify-center flex-1 h-40 px-6 py-4 border-b-2 lg:border-b-0 w-full lg:w-auto lg:border-r-2 border-ccu-green items-center'>
						<h1 className='text-ccu-dark font-Ubuntu-Regular text-2xl text-center'>
							<strong className='font-Ubuntu-Bold'>Líderes</strong> <br /> en <strong className='font-Ubuntu-Bold'>Aguas Puras</strong> y <strong className='font-Ubuntu-Bold'>Saborizadas</strong> 
						</h1>
					</div>
					<div className='flex justify-center flex-1 h-40 px-6 py-4 border-b-2 lg:border-b-0 w-full lg:w-auto lg:border-r-2 border-ccu-green items-center'>
						<h1 className='text-ccu-dark font-Ubuntu-Regular text-2xl text-center'>
							<strong className='font-Ubuntu-Bold'>2da compañía cervecera</strong> Argentina
						</h1>
					</div>
					<div className='flex flex-1 h-40 px-6 py-4 justify-center items-center'>
						<h1 className='text-ccu-dark font-Ubuntu-Regular text-base text-center text-2xl'>
							<strong className='font-Ubuntu-Bold text-2xl'>Líderes</strong> <br /> en <strong className='font-Ubuntu-Bold text-2xl'>Sidra</strong>
						</h1>
					</div>
				</div>
				<div className='flex flex-col text-ccu-green w-full items-center my-4 p-8 lg:p-0'>
					<p className='text-xl font-bold text-center font-Ubuntu-Bold'>
						Nos apasiona crear experiencias para compartir juntos un mejor
						vivir.
						<br />
						<span className='text-ccu-dark text-xl font-Ubuntu-Bold'>
							En CCU Argentina sentimos pasión por lo que hacemos y por eso
							<br className=' hidden lg:flex' /> millones de personas prefieren nuestras marcas todos lo
							días.
						</span>
					</p>
				</div>
				<div className='flex flex-col text-ccu-dark w-full items-center mb-4 p-4'>
					<p className=' text-xl lg:text-base text-center'>
						Si sos de los que quieren desafíos permanentes y trabajar con marcas
						líderes
					</p>
					<div className='flex flex-row'>
					<a
						href='https://postulacionesccuargentina.hiperjob.com/ofertas'
						target='_blank'
						rel='noopener noreferrer'
						className={cx({
							shadow_btn: true,
							'text-xl lg:text-4xl my-4 font-bold shadow bg-ccu-green text-white px-2 font-display': true,
						})}
					>
						Te invitamos a ser parte de CCU
					</a>
					</div>
				</div>
			</div>
		</section>
	);
};

export default We;
